import { useCallback } from "react";
import { generatePath, useNavigate } from "react-router";

import type { Plan_DesignPageQuery } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";

import { ToastAction } from "@/components/ui/toast/toast";

import * as Shared from "../../../../../_shared";
import { usePlanArticleUpdateMutation } from "../../repository/mutation/use-plan-article-update-mutation";

type Props = {
	hotelID: string;
	planID: string;
	data: Plan_DesignPageQuery;
};

export const useInitialized = ({ hotelID, planID, data }: Props) => {
	const { onUpdate: _onUpdate } = usePlanArticleUpdateMutation({ hotelID, planID });
	const { article, tags, tagsLocation } = data.plan;

	const navigate = useNavigate();
	const planListPath = generatePath(PATHS.HOTEL.RESERVATION_PAGE.MAGAZINE.LIST.PLAN, { hotelID });

	const onNavigateToPlanList = useCallback(() => {
		navigate(planListPath);
	}, [planListPath, navigate]);

	const onUpdateSuccessCallback = useCallback(() => {
		notifyUserEventInfo({
			title: "プラン記事を保存しました",
			action: (
				<ToastAction onClick={onNavigateToPlanList} altText="一覧に戻る">
					一覧に戻る
				</ToastAction>
			),
		});
	}, [onNavigateToPlanList]);

	const { articleHTML, onSetArticleHTML, tag, onSetTag, isDirty, isValid, onUpdate } =
		Shared.Model.UseCase.useCreateMagazineEditorForDefaultModel({
			article,
			tagList: tags,
			/**
			 * tagsLocation の index は以下の定義順となっている
			 */
			regionTag: tagsLocation[0],
			prefectureTag: tagsLocation[1],
			cityTag: tagsLocation[2],
			onUpdate: _onUpdate,
			onUpdateSuccessCallback,
		});

	return {
		data,
		articleHTML,
		onSetArticleHTML,
		tag,
		onSetTag,
		isDirty,
		isValid,
		onUpdate,
	};
};
